<template>

<div>
      <div class="container" v-if="twoTables">
            <div class="col-sm-12">
                <div class="panel panel-default">
                    <div class="panel-body">
                        <table class="table b-table table-sm" id="tabela2">
                            <thead>
                                <tr>
                                    <th>{{helperTitle}}</th>
                                </tr>
                            </thead>
                            <thead class="thead-dark">
                                <tr>
                                    <th class="text-center" style="" :key="key" v-for="(head, key) of helperHeader">{{head.title}}</th>
                                </tr>
                            </thead>
                            <tbody v-if="helperItens.length">
                                 <tr v-for="(item, key) of helperItens" :key="key">
                                    <td class="text-center" :key="key" v-for="(itemHeader, key) of helperHeader">
                                        {{itemHeader.click ? null : itemHeader.notToDecimal ? item[itemHeader.name] :  convertToDecimal(item[itemHeader.name])}}
                                        <a v-if="itemHeader.click" href="" @click.prevent.stop="showDetails(item, key);"><b>{{itemHeader.notToDecimal ? item[itemHeader.name] :  convertToDecimal(item[itemHeader.name]) }}</b></a>
										<md-tooltip v-if="itemHeader.click" style="color:red;">Clique para exibir detalhes...</md-tooltip>
                                    </td>
                                </tr>
                                 <tr>
                                    <td class="text-center" style="background-color:#ccc;"><b>Totais:</b></td> 
                                    <td class="text-center" style="background-color:#ccc;"  v-for="(head, key) of helperHeaderTotals" :key="key">{{ totals(secondTotals[head], head, helperHeader) }}</td>
                                </tr> 
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

    <div class="container" v-show="itens.length && !twoTables">
      	<div class="col-md-12">
			<div class="panel panel-default">
				<div class="panel-body">
					<table class="table b-table table-sm" id="tabela">
						<thead class="thead-dark">
							<tr>
								<th class="text-center">{{title_header}}</th>
							</tr>
						</thead>
						<tbody>
							<template v-for="(name, key) of headerItens">
								<tr :key="key">
									<td>
										<div>
											<a href="" @click.prevent.stop="showDetails( name, key);"><b>{{ name }}</b></a>
											<md-tooltip style="color:red;">Clique para exibir detalhes</md-tooltip>
										</div>
									</td>
								</tr>
							</template>
						</tbody>
					</table>
				</div>
			</div>
		</div>
    </div>

    <div class="container" v-if="show_detail">
            <div class="col-sm-12">
                <div class="panel panel-default">
                    <div class="panel-body">
                        <table class="table b-table table-sm" id="tabela2">
                            <thead>
                                <tr>
                                    <th>{{title}}</th>
                                </tr>
                            </thead>
                            <thead class="thead-dark">
                                <tr>
                                    <th class="text-center" style="" :key="key" v-for="(head, key) of header">{{head.title}}</th>
                                </tr>
                            </thead>
                            <tbody>
                               <tr v-for="(item, key) of itens" :key="key">
                                    <td class="text-center" v-for="(head, key) of header" :key="key">
                                     
                                        {{head.clickCustom ? null : head.notToDecimal ? item[head.name] :  convertToDecimal( item[head.name])}}

                                        <a v-if="head.clickCustom" href="" @click.prevent.stop="head.linkFunc(item, key);"><b>{{head.notToDecimal ? item[head.name] :  convertToDecimal(item[head.name]) }}</b></a>
										<md-tooltip v-if="head.clickCustom" style="color:red;">Clique para exibir detalhes...</md-tooltip>
                                    
                                         
                                    </td>
                                </tr>
                                <tr>
                                    <td class="text-center" style="background-color:#ccc;"><b>Totais:</b></td>
                                    <td class="text-center" style="background-color:#ccc;" :key="key" v-for="(head, key) of firstHeaderTotals">
                                        {{ totals(firstTotals[head], head, header) }}
                                    </td>
                                </tr> 
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['helperTitle', 'helperHeader', 'helperItens', 'title_header','headerItens' , 'title', 'header', 'itens', 'show_detail', 'showDetails', 'twoTables', 'clickCustom','linkFunc'],
    methods: {
        totals(value, head_name, data) {
                const filtered = data.filter((element, key) => {
                    return element.name === head_name
                });
               if(filtered[0].notToDecimal) {
                    return value
               } 
               return this.convertToDecimal(value);

            //console.log('head_name >> ', this.helperItens[head_name], ' head_name ', head_name, ' itens ', this.helperItens);
            
        },
        convertToDecimal(number) {
            if(isNaN(number)) {
               return number 
            }
            return Number(parseFloat(number).toFixed(2)).toLocaleString('pt', {
                minimumFractionDigits: 2
            });
        },
        initFirstTotals() {
            let removeToTotal = null;
            const self = this;
            this.firstTotals = [];

            this.header.forEach(element => {
                this.firstTotals[element.name] = this.firstTotals[element.name] || 0;
                
                if(element.removeTotal) {
                    removeToTotal = element.name
                }   
                this.itens.forEach(elementToCal => {
                    if(element.calc === 'sum') {
                        this.firstTotals[element.name] += parseFloat(elementToCal[element.name]);   
                    } else if(element.calc === 'custom') {
                        this.firstTotals[element.name] = 'Here'
                        element.functionToCal(this.itens, element.name);
                    } else {
                        this.firstTotals[element.name] = '-';   
                    }
                })
            });
            if(removeToTotal) {
                delete this.firstTotals[removeToTotal];
            }

            this.firstHeaderTotals = Object.keys(this.firstTotals); 
            
            }, 
        initSecondTotals() {
            let removeToTotal = null;

            this.helperHeader.forEach(element => {
                this.secondTotals[element.name] = this.secondTotals[element.name] || 0;
                
                if(element.removeTotal) {
                    removeToTotal = element.name
                }   

                this.helperItens.forEach(elementToCal => {
                    if(element.calc === 'sum') {
                        this.secondTotals[element.name] += parseFloat(elementToCal[element.name]);   
                    } else if(element.calc === 'custom') {
                        if(!this.secondTotals[element.name]) {
                            this.secondTotals[element.name] = element.calcCustom(this.helperItens, element.name);   
                        }
                    } else {
                        this.firstTotals[element.name] = '-';   
                    }
                })
            });
            if(removeToTotal) {
                delete this.secondTotals[removeToTotal];
            }

            this.helperHeaderTotals = Object.keys(this.secondTotals);
            }
    },
    beforeMount() {
      this.initSecondTotals();
      this.initFirstTotals();
    },
    created() {
       // console.log("create ", this.helperItens)
    },
    data() {
        return {
            firstTotals: [],
            firstHeaderTotals: [],
            secondTotals: [],
            helperHeaderTotals: []
        }   
    },
    watch: {
        itens: {
            handler: function(newVal) {
                this.initFirstTotals();
                console.log('newVal ', newVal)
            },
            deep: true
        }
    }
}
</script>

<style>

</style>